import { flexRender } from "@tanstack/react-table";
import "../../style/table.scss";

/**
 * Body for the table component.
 * @param {object} props
 * @param {import("@tanstack/react-table").RowModel} props.rowModel Provides access to the table rows.
 * @param {(row: import("@tanstack/react-table").Row) => void} [props.onRowClick] Called when a row is clicked.
 */
function TableBody({ rowModel, onRowClick }) {
    return (
        <tbody>
            {rowModel.rows.map((row) => (
                <tr
                    key={row.id}
                    className={`${onRowClick ? "" : "no-hover"}`}
                    style={{
                        position: "relative",
                        cursor: onRowClick ? "pointer" : "default",
                    }}
                    onClick={(e) => {
                        if (e.target.tagName.toLowerCase() !== "button") {
                            onRowClick?.(row);
                        }
                    }}
                >
                    {row.getVisibleCells().map((cell) => (
                        <td key={cell.id} style={{ width: cell.column.getSize() }}>
                            {flexRender(cell.column.columnDef.cell, cell.getContext())}
                        </td>
                    ))}
                </tr>
            ))}
        </tbody>
    );
}

export default TableBody;
